<template>
  <div class="logo" @click="$router.push('/')" :class="{disableClick}">
    <div class="eye-container" ref="anchor">
      <div style="position:relative">
        <img src="@/assets/studio-page/header/container.svg" class="eye-containerr" />
        <img src="@/assets/studio-page/header/eye.svg" class="eye" :style="eyeStyle" />
        <img src="@/assets/studio-page/header/mountains.svg" class="mountains" />
      </div>
    </div>
    <div class="text" :style="{'visibility': hideText ? 'hidden' : 'default'}">
      <img src="@/assets/studio-page/header/logo-text.png" class="header-img" />
    </div>
  </div>
</template>

<script>
import throttle from "lodash.throttle"
export default {
  props: {
    max: {
      type: Number,
      default: 8,
    },
    hideText: {
      type: Boolean,
      default: false,
    },
    disableClick: {
      type: Boolean,
      default: false,
    }
  },
  data() {
    return {
      throttle: null,
      screen: {
        width: 0,
        height: 0
      },
      anchor: {
        x: 0,
        y: 0
      },
      eyeStyle: {},
    }
  },
  methods: {
    mouseListen(e) {
      let x = e.clientX
      let y = e.clientY
      let diffX = 0
      let diffY = 0
      if (x < this.anchor.x) {
        diffX = -(this.anchor.x - x) / this.anchor.x
      } else {
        diffX = (x - this.anchor.x) / (this.screen.width - this.anchor.x)
      }
      if (y < this.anchor.y) {
        diffY = -(this.anchor.y - y) / this.anchor.y
      } else {
        diffY = (y - this.anchor.y) / (this.screen.height - this.anchor.y)
      }
      let transX = diffX * this.max
      let transY = diffY * this.max
      this.eyeStyle = {
        transform: `translate(${transX}px,${transY}px)`
      }
    },
  },
  mounted() {
    let anchor = this.$refs.anchor.getBoundingClientRect()
    this.anchor.x = anchor.left
    this.anchor.y = anchor.top - 50
    this.screen.width = document.body.clientWidth
    this.screen.height = document.body.clientHeight

    // only do this if we are not a phone
    if (this.screen.width > 900) {
      this.throttle = throttle(this.mouseListen, 100)
      document.addEventListener("mousemove", this.throttle)
    }
  },
  beforeDestroy() {
    this.throttle.cancel()
    document.removeEventListener("mousemove", this.throttle)
  },
}
</script>

<style scoped lang="scss">
.logo {
  width: 200px;
  height: auto;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  flex-direction: row;
  transition: 0s all;

  &:not(.disableClick) {
    cursor:pointer;
    opacity: 0.6;
    transition: 0.2s opacity;

    &:hover {
      opacity: 1;
    }
  }
}
.header-img {
  width: 100%;
}
.eye-container {
  margin-right: 10px;
  position: relative;
  width:100px;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.eye-container img {
  width: 100%;
  height: auto;
}
.text {
  width: 200px;
  height: auto;
  display: flex;
  flex-direction: column;
  justify-content: center;
}
.mountains,
.eye {
  position: absolute;
  top: 0;
  left: 0;
}
.eye-containerr {
  margin-top: -2px;
}

.eye {
  transition: 1s transform ease-out;
}

@media only screen and (max-width: 600px) {
  .logo {
    width: 100px !important;
  }
}
</style>